import { css } from 'styled-components';
import { ContentProps } from './models';

const submitButtonWidth = css`
  width: 252px;
`;

const stickyWrapperHeight = 80;

export const Content = css<ContentProps>(({ theme }) => {
  return css`
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 20px 20px;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 10;
    height: 100%;

    > .slogan {
      flex: 1 0 0;
      justify-content: end;
      margin-bottom: 40px;

      @media only screen and ${theme.device.mobileXL} {
        margin-top: 55px;
      }
    }

    .link {
      font-weight: 500;
      text-decoration: underline;
    }

    > .title {
      color: ${theme.colors.primaryDeepBlue};
      font-weight: 600;
      white-space: pre-wrap;
      margin-top: 1px;
      font-size: 18px;
      line-height: 27px;
      max-width: 327px;
      margin-bottom: 44px;

      @media only screen and ${theme.device.mobileXL} {
        font-size: 25px;
        line-height: 30px;
        max-width: 494px;
      }
    }

    > .legal-consent {
      color: ${theme.colors.darkGray};
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      max-width: 960px;
      margin-bottom: 20px;

      @media only screen and ${theme.device.mobileXL} {
        margin-bottom: 20px;
      }
    }

    > .submit-button-wrapper {
      > .submit-button {
        ${submitButtonWidth};
        height: 50px;
        margin: 40px 0 10px;
      }
    }

    > .legal-notice {
      max-width: 1040px;
      color: ${theme.colors.darkGray};
      font-size: 10px;
      font-weight: 400;

      @media only screen and ${theme.device.mobileXL} {
        width: 90%;
        margin: 44px auto 0;
        padding-bottom: 75px;
      }
    }

    &.mobile-bottom-container {
      > .sticky-bottom-content {
        width: 100%;
        position: fixed;
        bottom: 0;

        > .scroll-notice {
          background: ${theme.colors.primaryDeepBlue};
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          flex-shrink: 0;
          padding: 8px 16px;
        }

        .submit-button {
          width: 255px;
          height: 40px;
          margin: 0;
        }

        > .sticky-button-wrapper {
          padding: 10px;
          background-color: white;
          height: ${stickyWrapperHeight}px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0px -6px 8px -4px rgba(24, 39, 75, 0.04);

          > .submit-button-container {
            position: relative;
            width: 100%;
            display: flex;
            justify-content: center;

            > .overlay {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: transparent;
            }
          }
        }
      }
    }

    > .sticky-button-wrapper-placeholder {
      padding-top: ${stickyWrapperHeight / 2}px;
    }
  `;
});
